import { SharedPagedRequest } from "@sharedcommon/model/shared-page-request.model";

export class CustomerFilterDto extends SharedPagedRequest {
  inBusinessUnitIds: string[];
  codes: string[];
  label: string;
}